const BRAND_STATUSES = {
  active: { name: "active", id: "active" },
  blocked: { name: "blocked", id: "blocked" },
  disabled: { name: "disabled", id: "disabled" },
  error: { name: "error", id: "error" },
};

export default BRAND_STATUSES;
